export enum UserType {
  admin = 'admin',
  user = 'user',
}
